import { reactive } from 'vue'

// 创建一个响应式状态存储toast信息
const state = reactive({
  visible: false,
  message: '',
  duration: 3000, // 默认显示3秒
  small: false
})

// 导出toast服务
export const toastService = {
  showSmall(message, duration = 3000) {
    this.show(message, duration, true)
  },
  // 显示toast
  show(message, duration = 3000, small = false) {
    state.visible = true
    state.message = message
    state.duration = duration
    state.small = small
    
    // 自动隐藏
    setTimeout(() => {
      this.hide()
    }, duration)
  },
  
  // 隐藏toast
  hide() {
    state.visible = false
    state.message = ''
  },
  
  // 获取当前状态
  getState() {
    return state
  }
} 